// Hide images that are broken.
(function($){
    'use strict';
    //Check if we are on sandbox or if we are previewing an entry from cms.
    var pageHost = document.location.host;
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    var errorClass = isSandbox() ? 'broken-image' : 'image-error';

    $('img').each(function() {
        if (this.complete && this.hasAttribute('src')) {
            if (this.naturalHeight === 0) {
                if (!isFirefox || !isSvg(this)) {
                    // Firefox doesn't return natural width for SVG images without viewPort size
                    $(this).addClass(errorClass); //Broken image
                }
            }
        } else { //Attach the event
            $(this).error(function(e) {
                $(e.target).addClass(errorClass);
            });
        }
    });

    ///////////////

    function isSandbox() {
        return pageHost.match(/^[m\.]?[\w]+-.*\.sandbox/ig) !== null || pageHost.match(/internal\/cms\/preview/ig) !== null;
    }

    function isSvg(domImage) {
        return domImage.getAttribute('src').indexOf('.svg') > 0;
    }
})(jQuery);
